<template>
	<div class="banner7">
		<!-- curpage == 7 -->
		<slider :touch="true" @change="changePage" v-model="sliderIndex" :interval="3000" :speed="200" :stopOnHover="true" :autoplay="true" :control-btn="false" animation="normal"
			class="bannerSwiper" style="height: 90vh; width: 90vw;">
			<!-- Market Insights -->
			<slider-item class="slideritem" v-for="(im, index) in swiperList" :key="index">
				<div
					v-for="(item, index) in im"
					:key="index.toString()"
					class="texchnologyItem"
					@click="showGame(index, 2)">
					<div class="texchnologyItemItm">
						<img class="game" :src="item.url" >
						<img :class="curGame == index ? 'gamebg gamebgAni' : 'gamebg'" src="../../assets/gamebg.png" >
						<p class="title">
							{{item.name}}
						</p>
					</div>
				</div>
			</slider-item> 
		</slider>
	</div>
</template>

<script>
	
	import {
		Slider,
		SliderItem
	} from 'vue-easy-slider'
	export default {
		props: ['curpage'],
		components: {
			Slider,
			SliderItem
		},
		data () {
			return {
				list: [ //
					{
						name: 'Match Tile Scenery',
						url: require('../../assets/gameicon/Match Tile Scenery.png')
					},
          {
            name: 'Whispers',
            url: require('../../assets/gameicon/Whispers.png')
          },
          {
            name: 'Bingo Journey',
            url: require('../../assets/gameicon/Bingo Journey.png')
          },
          {
            name: 'North Tower',
            url: require('../../assets/gameicon/North Tower.png')
          },
          {
            name: 'Grand Cash Slots',
            url: require('../../assets/gameicon/Grand Cash Slots.png')
          },
          {
            name: 'Farm Story',
            url: require('../../assets/gameicon/Farm Story.png')
          },
          {
            name: 'Double Win Slots',
            url: require('../../assets/gameicon/Double Win Slots.png')
          },
          {
            name: 'Plague Invader',
            url: require('../../assets/gameicon/Plague Invader.png')
          },
          {
            name: 'Lucky Hit Slots',
            url: require('../../assets/gameicon/Lucky Hit Slots.png')
          },
          {
            name: 'Meow Pop Blast',
            url: require('../../assets/gameicon/Meow Pop Blast.png')
          },
          {
            name: 'Double Rich Slots',
            url: require('../../assets/gameicon/Double Rich Slots.png')
          }
				],
				play: false,
				sliderIndex: 0,
				curGame: 0, // 默认所有的游戏图标都是遮挡状态，点击某一个图标之后，展示图标
				clickbyuser: false,
        swiperList: []
			}
		},
		watch: {
			'curpage': {
				handler(newvalue, oldvalue) {
					if (newvalue === 7) {
						this.sliderIndex = 0
						this.changePage(0)
						// setTimeout(()=> {
						// 	this.showGame(0, 2)
						// }, 200)
					}
				}
			}
		},
    mounted() {
      // 将list组合每3个一组的数组
      let result = [];
      for (let i = 0; i < this.list.length; i += 3) {
        // 使用 slice 方法来获取当前位置开始的 chunkSize 个元素
        let chunk = this.list.slice(i, i + 3);
        result.push(chunk);
      }
      this.swiperList = result;
    },
		methods: {
			showGame (index, max) {
				this.curGame = index
			},
			changePage (page) {
        this.curGame = 0
					setTimeout(()=> {
						this.curGame = 1
						setTimeout(()=> {
							this.curGame = 2
							setTimeout(()=> {
								this.curGame = -1
							}, 400)
						}, 400)
					}, 400)
			}
		}
	}
</script>

<style lang="scss" scoped>
	// body {
	// 	width: 3000px;
	// 	height: 2300px;
	// }
	/deep/ .slider-btn {
		display: none !important;
	}

	/deep/ .slider-indicator-icon {
		background-color: rgba(0, 0, 0, 0) !important;
		margin: 1px 0.1rem !important;
		border: 1px solid #000 !important;
		width: 10px !important;
		height: 10px !important;
	}
	
	/deep/ .slider-indicator-active {
		background-color: #000 !important;
	}

	.banner7 {
		height: 100vh;
		width: 100vw;
		// width: 187.5rem;
		// height: 143.75rem;
		padding-top: 1.25rem;
		background-color: #fff;
		text-align: left;
		box-sizing: border-box;
		position: relative;
		padding-left: 1.5625rem;
		position: relative;
		.bannerSwiper {
			position: absolute;
			bottom: 0.625rem;
			width: 100vw;
			display: flex;
			box-sizing: border-box;
			overflow: hidden;
			// background-color: red;
			.slideritem {
				display: flex;
				width: 100vw;
				// height: 100%;
				// padding-top: 15%;
				box-sizing: border-box;
				// padding-left: 3.125rem;
				box-sizing: border-box;
				display: flex;
				justify-content: flex-start;
				.texchnologyItem {
					// width: 23.625rem;
					width: 30%;
					// height: 100%;
					// margin-right: 0.225rem;
					position: relative;
					// margin-top: 10rem;
					.texchnologyItemItm {
						margin: 0 auto;
						text-align: center;
						height: 100%;
						img {
							width: 70%;
							bottom: 3.375rem;
							position: absolute;
						}
						.game {
							width: 50%;
							transform: translateX(-50%);
						}
						.gamebg {
							background-color: #fff;
							transform: translateX(-50%);
						}
						.gamebgAni {
							animation: gameBgani 0.2s;
							animation-fill-mode:forwards;
							-webkit-animation-fill-mode:forwards; /* Safari 和 Chrome */
							animation-timing-function:ease-in;
						}
						.title {
							color: #000;
							font-size: 0.567rem;
							padding: 0;
							margin: 0;
							line-height: 2.125rem;
							box-sizing: border-box;
							position: absolute;
							bottom: 1rem;
							width: 100%;
							text-align: center;
							font-family: 'PilatTest-Bold';
						}
					}
					.desc {
						color: #000;
						font-size: 1.5em;
						padding: 2px;
						padding-left: 3.125rem;
					}
				}
			}
		}
	}
	@keyframes gameBgani {
		from {
			bottom: 3.375rem;
			transform: rotate(-25deg);
			left: 0;
		}
		to {
			bottom: 8.4rem;
			transform: rotate(-25deg);
			left: 0;
		}
	}
</style>
